// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Wh2dx","productName":"Table_productName__2q6iu"};